import { IRect, IRectType } from 'annotation-tools/utils';

export type RawRectangleType = {
  x: number;
  y: number;
  w: number;
  h: number;
};

export const RawRectangleToIRect = (rectRaw: RawRectangleType) =>
  IRect({
    top: rectRaw.y,
    left: rectRaw.x,
    width: rectRaw.w,
    height: rectRaw.h
  });

export const IRectToRawRectangle = (rect: IRectType) => ({
  x: rect.left,
  y: rect.top,
  w: rect.width,
  h: rect.height
});
